export default function(data, grader) {
  var vm = ko.mapping.fromJS(data);
  vm.request = null;
  vm.editing = ko.observable(false);
  /*------------------------------------------------GRADE ADJUSTMENT--------------------------------------------------*/
  vm.old_grade_adjustment_input = ko.observable(vm.grade_adjustment_input());
  vm.grade_adjustment = ko.computed(function() {
    return vm.grade_adjustment_input() * vm.grade_adjustment_multiplier();
  });

  vm.grade_adjustment_active.subscribe(function (value) {
    if (!value && vm.grade_adjustment_input() > 0) {
      vm.grade_adjustment_input(0);
      vm.saveGradeAdjustment();
    }
  });

  vm.grade_adjustment_multiplier.subscribe(function (value) {
    //Hack to force grade_adjustment computed to refresh before saving
    vm.grade_adjustment_input.valueHasMutated();

    if (vm.grade_adjustment_input() > 0) {
      vm.saveGradeAdjustment();
    }
  });

  vm.computed_adjustment_input = ko.computed({
    read: function () {
      return vm.grade_adjustment_input();
    },
    write: function (value) {
      var old_grade_adjustment_input = vm.grade_adjustment_input();
      vm.grade_adjustment_input(value);
      if (vm.computed_adjustment_input.isValid()) {
        vm.old_grade_adjustment_input(old_grade_adjustment_input);
      }
    }
  }).extend({min: 0, max: 100});

  vm.saveGradeAdjustment = function(silent) {
    if (vm.computed_adjustment_input.isValid()) {
      return vm.saveGrade(silent).done(function () {
        vm.old_grade_adjustment_input(vm.grade_adjustment_input());
      });
    }
  };
  /*----------------------------------------------------NOTES---------------------------------------------------------*/
  vm.old_notes = ko.observable(vm.notes());
  vm.computed_notes = ko.computed({
    read: function () {
      return vm.notes();
    },
    write: function (notes) {
      var old_notes = vm.notes();
      vm.notes(notes);
      vm.old_notes(old_notes);
    }
  });
  vm.notes_redactor_opts = {
    clickCallback: function (e) {
      vm.editing('notes');
    },
    blurCallback: function (e) {
      vm.save();
    }
  };

  vm.saveNotes = function(silent) {
    return vm.saveGrade(silent).done(function () {
      vm.old_notes(vm.notes());
    });
  };
  /*----------------------------------------------------AUTO GRADE NOTES----------------------------------------------*/
  vm.old_auto_grade_notes = ko.observable(vm.auto_grade_notes());
  vm.computed_auto_grade_notes = ko.computed({
    read: function () {
      if (!_.isEmpty(vm.auto_grade_notes())) {
        return vm.auto_grade_notes();
      } else {
        return vm.compiled_auto_grade_notes();
      }
    },
    write: function (notes) {
      var old_notes = vm.auto_grade_notes();
      vm.auto_grade_notes(notes);
      vm.old_auto_grade_notes(old_notes);
    }
  });
  vm.auto_grade_notes_redactor_opts = {
    clickCallback: function (e) {
      vm.editing('auto_grade_notes');
    },
    blurCallback: function (e) {
      vm.save();
    }
  };

  vm.saveAutoGradeNotes = function(silent) {
    return vm.saveGrade(silent).done(function () {
      vm.old_auto_grade_notes(vm.auto_grade_notes());
    });
  };

  /*----------------------------------------------------PERSISTENCE---------------------------------------------------*/
  vm.getGradeId = function(silent) {
    var deferred = $.Deferred();
    if (isNaN(parseInt(vm.id()))) {
      if (_.isEmpty(vm.request)) {
        vm.saveGrade(silent).done(function (response, status, xhr) {
          deferred.resolve(response.grade.id);
        });
      } else {
        vm.request.done(function (response, status, xhr) {
          deferred.resolve(response.grade.id);
        });
      }
    } else {
      deferred.resolve(vm.id());
    }
    return deferred;
  };

  vm.bindGrade = function(grade) {
    _.each(_.keys(grade), function (key) {
      if (!_.isObject(grade[key]) && !ko.isComputed(vm[key]))
        vm[key](grade[key]);
    });
  };

  vm.saveGrade = function(silent) {
    vm.request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.save_course_gradebook_grades_path(grader.course_id),
      data: {grade: ko.mapping.toJS(vm)},
      timeout: 60000
    });

    vm.request.done(function(response, status, xhr) {
      vm.bindGrade(response.grade);
      if (silent !== true)
        new Kadenze.Notice.success({});
    });

    vm.request.fail(function(xhr, status, msg) {
      new Kadenze.Notice.error({message: xhr.responseJSON && xhr.responseJSON.errors ? xhr.responseJSON.errors : Kadenze.I18n.t('notice.unexpected_error')});
    });

    return vm.request;
  };

  vm.save = function(silent) {
    var response = false;
    var was_editing = vm.editing();

    if (vm.editing() == 'notes') {
      response = vm.saveNotes(silent);
    } else if (vm.editing() == 'auto_grade_notes') {
      response = vm.saveAutoGradeNotes(silent);
    } else if (vm.editing() == 'grade_adjustment') {
      response = vm.saveGradeAdjustment(silent);
    }

    response && response.done(function () {
      vm.editing(false);

      //If one of the tabs were being edited, preserve their state
      if (was_editing == 'notes' || was_editing == 'auto_grade_notes') {
        $('a[href="#tab_grader-' + was_editing + '"]').tab('show');
      }
    });

    return response;
  };

  vm.undo = function () {
    if (vm.editing() == 'notes') {
      vm.notes(vm.old_notes());
    } else if (vm.editing() == 'grade_adjustment') {
      vm.grade_adjustment_input(vm.old_grade_adjustment_input());
    }
    vm.editing(false);
  };

  return vm;
}
